export default __webpack_public_path__ + "static/media/icn-wtd-distance-travelled.5482c8b3.svg";